import BannerSlider from '../components/BannerSlider';
import LogoScrollBar from '../components/LogoScrollBar';
import InfoSection from '../components/InfoSection';
import CardGroup from '../components/CardGroup';
import DemoForm from '../components/DemoForm';

export default function Home() {
  return (
    <>
      <BannerSlider />
      <LogoScrollBar />
      <InfoSection
        title="Title text of around 8 to 10 words"
        description="Description in around 30 words."
        image="/images/infosection1.jpg"
      />
      <InfoSection
        title="Title text of around 8 to 10 words"
        description="Description in around 30 words."
        image="/images/infosection2.jpg"
        reverse
      />
      <CardGroup />
      <DemoForm />
    </>
  );
}
